/*eslint-disable */
import React, { useState, useEffect } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import { Dropdown, Form as FormUi, Container } from "semantic-ui-react";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import CreateAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import { translate } from "react-i18next";
import { AllRegex } from "../../utils/validation";

const InsertVendorGroup = ({
  values,
  setFieldValue,
  touched,
  errors,
  editData,
  t,
}) => {
  const [vendors, setvendors] = useState([]);
  useEffect(() => {
    fetchAllVendor();
  }, []);
  const fetchAllVendor = () => {
    ReadAxios({ url: "transportermaster" })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setvendors([])
          : setStateVendor(res.data.resultSet);
      })
      .catch((err) => {
        console.log(err);
        setvendors([]);
      });
  };

  const setStateVendor = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        key: item.transporterCode,
        text: item.transporterName,
        value: item.transporterMasterId,
        raw: { ...item },
      };
    });
    setvendors(result);
  };

  const customerNo = localStorage.getItem('customerNumber')
  return isEmpty(editData) || values.vendors.length > 0 ? (
    <React.Fragment>
      <Formiker>
        <div className="container-fluid animated slideInDown pad w3-white">
          <div className="m-3 pl-3">
            <div className="ui form">
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("create.group_name.title") || "Group Name"}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.vendorGroupName && errors.vendorGroupName
                      ? true
                      : false
                  }
                >
                  <Fieldmik
                    type="text"
                    className="ui input "
                    style={{ width: "100%" }}
                    name="vendorGroupName"
                    placeholder={
                      t("create.group_name.placeholder") || "Group Name"
                    }
                  />
                </FormUi.Field>
                {touched.vendorGroupName && errors.vendorGroupName ? (
                  <div className="error-msg">
                    {t(
                      `create.group_name.error_msg.${errors.vendorGroupName}`
                    ) || errors.vendorGroupName}
                  </div>
                ) : null}
                <FormUi.Field width={1}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t(customerNo != 1158 ? "create.vendors.vendor_title" : "create.vendors.title") || "Vendors"}
                  </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={touched.vendors && errors.vendors ? true : false}
                >
                  <Dropdown
                    style={{ width: "100%" }}
                    placeholder={
                      t(customerNo != 1158 ? "create.vendors.vendor_placeholder" : "create.vendors.placeholder") || "Select Vendors"
                    }
                    multiple
                    search
                    name="vendors"
                    selection
                    options={vendors}
                    onChange={(name, data) =>
                      setFieldValue("vendors", data.value)
                    }
                    defaultValue={values.vendors}
                  />
                  {touched.vendors && errors.vendors ? (
                     <div className="error-msg">
                      {t(`create.vendors.error_msg.${errors.vendors}`) ||
                        errors.vendors}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              {editData.vendorGroupId ? (
                <FormUi.Group>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {t("create.group_code.title") || "Group Code"}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={
                      touched.vendorGroupCode && errors.vendorGroupCode
                        ? true
                        : false
                    }
                  >
                    <Fieldmik
                      type="text"
                      className="ui input "
                      name="vendorGroupCode"
                      disabled={editData.vendorGroupId ? true : false}
                      placeholder={
                        t("create.group_code.placeholder") || "Group Code"
                      }
                    />
                  </FormUi.Field>
                  {touched.vendorGroupCode && errors.vendorGroupCode ? (
                    <diuv>
                      {t(
                        `create.group_code.error_msg.${errors.vendorGroupCode}`
                      ) || errors.vendorGroupCode}
                    </diuv>
                  ) : null}
                </FormUi.Group>
              ) : (null)}

            </div>
          </div>
        </div>
        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit"
          >
            {t("create.action_button.submit") || "Submit"}
          </button>
        </Container>
      </Formiker>
    </React.Fragment>
  ) : (
    <LoadingPlaceholder />
  );
};

const FormikVendorGroup = withFormik({
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    let vendorIds = [];
    props.editData &&
      props.editData.vendors &&
      props.editData.vendors.map((item) => {
        vendorIds.push(item.transporterMasterId);
      });
    return {
      vendorGroupName: props.editData.vendorGroupName || "",
      vendors: vendorIds || [],
      vendorGroupCode: props.editData.vendorGroupCode || "",
    };
  },
  validationSchema: yup.object({
    vendorGroupName: yup.string().required("required").matches(AllRegex.Name, "name"),
    vendors: yup.array().min(1, "min"),
    vendorGroupCode: yup.string().optional(),
  }),
  async handleSubmit(values, { props }) {
    if (props.editData.vendorGroupId) {
      UpdateAxios({
        patchURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/group/${props.editData.vendorGroupId}`,
        payload: { ...values },
        uniqueId: props.editData.vendorGroupId,
      })
        .then((res) => {
          let alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: res.data.message,
          };
          props.successAlertDispatcher(alert);
          props.onFormSubmit();
        })
        .catch((err) => {
          console.log("error sku", err);
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.response.data.message,
          };
          console.log(err);
          props.errorAlertDispatcher(alert);
        });
    } else {
      CreateAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/group`,
        payload: { ...values },
      })
        .then((res) => {
          console.log("res", res);
          let alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: res.data.message,
          };
          props.successAlertDispatcher(alert);
          props.onFormSubmit();
        })
        .catch((err) => {
          console.log("error sku", err);
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.data.message,
          };
          props.errorAlertDispatcher(alert);
        });
    }
  },
})(InsertVendorGroup);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("vendor_group")(FormikVendorGroup)
);
